// Environment configuration for DFS Collections Debtor Portal
export const config = {
  // Serenity Star API
  serenityApiKey: import.meta.env.VITE_SERENITY_API_KEY || '3e0cac9e-2627-4227-8aea-c6d123cd6ac5',
  serenityBaseUrl: import.meta.env.VITE_SERENITY_BASE_URL || 'https://api.serenitystar.ai',
  
  // Dataset
  datasetId: import.meta.env.VITE_DATASET_ID || 'ecb704e4-044c-4489-b9be-bb60c177a0e8',
  
  // DFS Collection Agents
  chatbotAgent: import.meta.env.VITE_CHATBOT_AGENT || 'dfs-chatbot',
  segmentadorAgent: import.meta.env.VITE_SEGMENTADOR_AGENT || 'dfs-segmentador',
  comunicadorAgent: import.meta.env.VITE_COMUNICADOR_AGENT || 'dfs-comunicador',
  analizadorAgent: import.meta.env.VITE_ANALIZADOR_AGENT || 'dfs-analizador',
  evaluadorAgent: import.meta.env.VITE_EVALUADOR_AGENT || 'dfs-evaluador',
  judicialAgent: import.meta.env.VITE_JUDICIAL_AGENT || 'dfs-judicial',
  validadorAgent: import.meta.env.VITE_VALIDADOR_AGENT || 'dfs-validador',
} as const;

// Export individual constants for backward compatibility
export const API_KEY = config.serenityApiKey;
export const DATASET_ID = config.datasetId;
export const AGENT_CODES = {
  CHATBOT: config.chatbotAgent,
  SEGMENTADOR: config.segmentadorAgent,
  COMUNICADOR: config.comunicadorAgent,
  ANALIZADOR: config.analizadorAgent,
  EVALUADOR: config.evaluadorAgent,
  JUDICIAL: config.judicialAgent,
  VALIDADOR: config.validadorAgent,
} as const;

// Validate configuration on app start
export function validateConfig(): void {
  if (!config.serenityApiKey) {
    console.warn('VITE_SERENITY_API_KEY is not configured. API calls will fail.');
  }
  console.log('[Config] DFS Collections Debtor Portal');
  console.log('[Config] Using Serenity Star API:', config.serenityBaseUrl);
  console.log('[Config] Dataset ID:', config.datasetId);
}
